import * as R from "ramda";
import { validateObject, validateField } from "util/validation";
import { notBlank } from "../../util/ext";
import { curry } from "ramda";

const anthologyConstraints = {
  name: {
    presence: {
      allowEmpty: false,
      message: "^Title must not be blank",
    },
  },
  description: {
    presence: {
      allowEmpty: false,
      message: "^Description must not be blank",
    },
  },
  bisacCategories: {
    presence: {
      allowEmpty: false,
      message: "^At least one category must be selected",
    },
  },
};

export const validateAnthologyField = (field, value, errors = {}) =>
  validateField(anthologyConstraints, field, value, errors);

export const validateAnthology = R.partial(validateObject, [
  anthologyConstraints,
]);

export const hasError = curry((errors, field) => notBlank(errors[field]));

export const firstError = curry((errors, field) =>
  errors[field] ? errors[field][0] : "",
);
